var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrimaryToggleButton',{staticClass:"o-primary-btn--modal-option",style:(_vm.styleObject),attrs:{"value":_vm.value,"label":_vm.text},on:{"input":_vm.emitInput}})}
var staticRenderFns = []

export { render, staticRenderFns }